/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.trello.integration.OAuthRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const startRpc = {
  serviceName: 'com.hubspot.trello.integration.OAuthRpc',
  rpcName: 'start',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAA_mUaUPcPYLJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const callbackRpc = {
  serviceName: 'com.hubspot.trello.integration.OAuthRpc',
  rpcName: 'callback',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAA1r1QohIiacZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};